/**
 * Newsletter Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/newsletter.liquid
 * 
 */

import Vue from 'vue';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import {
    required,
    email,
    minLength,
    maxLength,
    sameAs,
    numeric
} from 'vuelidate/lib/validators';

import {apiEndpoint} from './../util/integration';

Vue.use(Vuelidate);

Vue.component('newsletter', {
    validations: {
        form: {
            firstname: {
                required
            },
            lastname: {
                required
            },
            email: {
                required,
                email
            },
            emailConfirmation: {
                required,
                sameAsEmail: sameAs('email')
            },
            postcode: {
                required,
                numeric,
                minLength: minLength(4),
                maxLength: maxLength(4)
            }
        }
    },

    data() {
        return {
            isNewsletterOpen: false,
            isSubmitting: false,
            isSuccess: false,
            serverMessages: [],
            form: {
                firstname: null,
                lastname: null,
                email: null,
                emailConfirmation: null,
                postcode: null
            }
        }
    },

    methods: {
        toggleNewsletter() {
            this.isNewsletterOpen = !this.isNewsletterOpen;
        },

        submitForm(e) {
            this.$v.$touch();
            // console.log('submit form', e);
            // console.log('vuelidator', this.$v);

            if (!this.$v.$error) {
                // console.log('form is valid');
                this.isSubmitting = true;

                let formData = new FormData();
                formData.append("first-name", this.form.firstname);
                formData.append("last-name", this.form.lastname);
                formData.append("email", this.form.email);
                formData.append("email_confirmation", this.form.emailConfirmation);
                formData.append("postcode", this.form.postcode); 
                // console.log('form', formData);

                axios.post(`${apiEndpoint}customer/subscribe?shop=${Shopify.shop}`, formData).then((response) => {
                    // console.log(response.data);
                    if (response.data.success) {
                        this.isSuccess = true;
                    } else {
                        this.serverMessages = response.data.messages;    
                    }

                }).catch((error) => {
                    console.log(error);
                    this.serverMessages = ['Error occurred on server, please try again later.'];

                }).finally(() => {
                    this.isSubmitting = false;
                });

            // } else {
            //     console.log('form is invalid');
            }
        }
    }
});